const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReembolso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135.26583 101.44937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m24.87118,75.53482v11.0179c3.67949,0,7.31099,2.63636,7.31099,6.2582h70.00771c0-3.62185,3.63179-6.2582,7.31099-6.2582v-34.56905c-1.32221,0-2.6383-.34045-3.7819-.94476",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.66261,83.09274c-.00714,0-.01429,0-.02143-.00143-.32289-.01143-.57435-.28146-.56292-.60578l.1043-2.94175c.01143-.32289.27574-.62864.60578-.56292.32289.01143.57435.28146.56292.60578l-.1043,2.94175c-.01143.31575-.27003.56435-.58435.56435Zm.41719-11.76843c-.00714,0-.01429,0-.02143-.00143-.32289-.01143-.57435-.28146-.56292-.60578l.1043-2.94175c.01143-.32289.30861-.62578.60578-.56292.32289.01143.57435.28146.56292.60578l-.1043,2.94175c-.01143.31575-.27003.56435-.58435.56435Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.29828,93.38101c-.00714,0-.01429,0-.02143-.00143-.32289-.01143-.57578-.28289-.56292-.60578l.05286-1.46159c.01143-.32289.30575-.6315.60578-.56292.32289.01143.57578.28289.56292.60578l-.05286,1.46159c-.01143.31575-.27003.56435-.58435.56435Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.15499,47.51758l-9.05164-33.36296c-3.55083.96337-7.74615-.62977-8.69458-4.12553L17.84358,28.36006c.94843,3.49576-1.86614,6.99074-5.41725,7.95418l9.05164,33.36296c3.55111-.96345,7.74622.63005,8.69458,4.12553l67.56519-18.33098c-.94835-3.49548,1.86642-6.99082,5.41725-7.95418Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.18801,15.44677c-.25717,0-.49434-.17145-.56578-.43148l-.3829-1.41158c-.08287-.31432.10001-.63436.41147-.72008.31432-.08001.63436.10001.72008.41147l.3829,1.41158c.08287.31432-.10001.63436-.41147.72008-.05143.01429-.10287.02-.1543.02Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.44045,49.54193c-.25717,0-.49434-.17145-.56578-.43148l-.77151-2.84031c-.08287-.31146.10001-.63436.41147-.72008.31432-.08572.63436.10001.72008.41147l.77151,2.84031c.08287.31146-.10001.63436-.41147.72008-.05143.01429-.10287.02-.1543.02Zm-3.08319-11.3641c-.25717,0-.49434-.17145-.56578-.43148l-.77151-2.84317c-.08287-.31432.10001-.63436.41147-.72008s.63436.10001.72008.41147l.77151,2.84317c.08287.31432-.10001.63436-.41147.72008-.05143.01429-.10287.02-.1543.02Zm-3.08319-11.36696c-.25717,0-.49434-.17145-.56578-.43148l-.77151-2.84031c-.08287-.31146.10001-.63436.41147-.72008.30861-.08001.63436.10001.72008.41147l.77151,2.84031c.08287.31146-.10001.63436-.41147.72008-.05143.01429-.10287.02-.1543.02Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.13503,59.47731c-.25717,0-.49434-.17145-.56578-.43148l-.3829-1.41158c-.08287-.31432.10001-.63436.41147-.72008.30861-.08287.63436.10001.72008.41147l.3829,1.41158c.08287.31432-.10001.63436-.41147.72008-.05143.01429-.10287.02-.1543.02Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.38515,41.50168l-6.84098,3.94951c-2.33051,1.3457-3.86865.49401-11.2848-1.10893l-1.38819.8014,6.01941,4.14898-1.21455.70128c-.29821.17226-.14185.63036.19932.58526,8.93946-1.18108,13.17725-2.85617,13.17725-2.85617l19.67034-11.35664s6.78397-3.91649,4.08676-4.90192c-2.99847-1.09533-9.19213,2.39746-9.19213,2.39746l-7.57573,4.37382-12.54429-4.39506-.75982.43868,8.9922,8.28817",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "54.47253 44.11389 53.9831 48.49643 52.82128 49.39748 50.01464 46.75561",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.01895,
    y1: 60.67024,
    x2: 68.9261,
    y2: 53.13984,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReembolso);
export default __webpack_public_path__ + "static/media/reembolso.276db9946c69a9cd3d9be18ecfde962d.svg";
export { ForwardRef as ReactComponent };